class CartDrawer extends HTMLElement {
  constructor() {
    super();
    this._cartUpdateInFlight = false;
    this._cartUpdatePending = false;
    this.bindEvents();
    document.addEventListener('keydown', this.handleEscapeKeyPress.bind(this));
    document.addEventListener('cart:updated', this.handleCartUpdate.bind(this));
    this.setClearCartButton();
  }

  bindEvents() {
    const drawerBtn = document.querySelector("[data-cart-drawer]");
    if (drawerBtn) {
      drawerBtn.addEventListener('click', this.openCartDrawer.bind(this));
    }
    this.querySelectorAll('[data-close-drawer]').forEach((button) =>
      button.addEventListener('click', this.closeDrawer.bind(this))
    );
    
    // Add overlay click event to close drawer
    const overlay = this.querySelector('.overlay');
    if (overlay) {
      overlay.addEventListener('click', this.closeDrawer.bind(this));
    }
    
    this.setupDialogEvents();
  }

  setupDialogEvents() {
    let lastFocusedElement = '';
    Array.from(this.querySelectorAll('.modal-dialog-button')).forEach((openBtn) => {
      openBtn.addEventListener('click', (e) => {
        const modalId = openBtn.dataset.modal;
        const dialog = this.querySelector(`cart-dialog#${modalId}`);
        if (dialog) {
          setTimeout(() => {
            dialog.classList.add('is-visible');
            setTimeout(() => {
              lastFocusedElement = openBtn;
              trapFocusElements(dialog);
            }, 600);
          }, 500);
        }
      });
    });
    Array.from(this.querySelectorAll('[data-dialog-close]')).forEach((closeBtn) => {
      closeBtn.addEventListener('click', (e) => {
        e.preventDefault();
        const dialog = closeBtn.closest('cart-dialog');
        dialog.classList.remove('is-visible');
        trapFocusElements(document.querySelector("cart-drawer"));
        setTimeout(() => {
          if (lastFocusedElement) {
            lastFocusedElement.focus();
          }
          lastFocusedElement = '';
        }, 400);
      });
    });
  }

  openCartDrawer(event) {
    event.preventDefault();
    fetch(this.dataset.url)
      .then(response => response.text())
      .then(html => {
        this.innerHTML = this.getSectionHTML(html, 'cart-drawer');
        
        setTimeout(() => {
          this.classList.add("is-visible");
          document.querySelector("body").classList.add("overflow-hidden");
        }, 50);
        
        this.querySelectorAll('[data-drawer-close]').forEach((button) =>
          button.addEventListener('click', this.closeDrawer.bind(this))
        );
        
        // Add overlay click event to close drawer after content refresh
        const overlay = this.querySelector('.overlay');
        if (overlay) {
          overlay.addEventListener('click', this.closeDrawer.bind(this));
        }
        
        setTimeout(() => {
        focusElement = event.target;
          trapFocusElements(document.querySelector("cart-drawer"));
        }, 500);

        const totalPrice =  document.querySelector("#cart-drawer-body-content").getAttribute("data-cart-price");
            freeShippingBarProgress(totalPrice);
        this.setupDialogEvents();
        this.setClearCartButton();
        window.HPCartLimits?.syncUI?.();


      })
      .catch(e => console.error(e));
  }

  renderContents(parsedState) {
    this.getSectionsToRender().forEach((section => {
    
      if (document.getElementById(section.id)) {
        const sectionHTML = this.getSectionHTML(parsedState.sections[section.id], section.selector);
        document.querySelector(section.selector).innerHTML = sectionHTML;

        const totalCount = new DOMParser().parseFromString(parsedState.sections[section.id], 'text/html').querySelector("#cart-drawer-body-content").getAttribute("data-cart-count");
        const priceElement = document.querySelector("[data-cart-price]");
         if (priceElement) {
          const totalPrice = parseInt(priceElement.dataset.cartPrice);
             freeShippingBarProgress(totalPrice);
        }
        const itemCountElement = document.querySelector("[data-item-count]");
        if (itemCountElement) {
          itemCountElement.classList.remove("hidden");

          if (totalCount == 0) {
            itemCountElement.classList.add("hidden");
          } else if (totalCount < 100) {
            itemCountElement.textContent = totalCount;
          } else {
            itemCountElement.textContent = '99+';
          }
        }
          trapFocusElements(document.querySelector("cart-drawer"));
        

        this.setupDialogEvents();
        this.setClearCartButton();
        window.HPCartLimits?.syncUI?.();
        this.querySelectorAll('[data-drawer-close]').forEach((button) =>
          button.addEventListener('click', this.closeDrawer.bind(this))
        );
        
        // Add overlay click event to close drawer after content refresh
        const overlay = this.querySelector('.overlay');
        if (overlay) {
          overlay.addEventListener('click', this.closeDrawer.bind(this));
        }

      }
    }));
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        section: 'cart-drawer',
        selector: 'cart-drawer'
      }
    ];
  }

  getSectionHTML(html, selector = 'cart-drawer') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector("cart-drawer").innerHTML;
  }

  closeDrawer(event) {
    event.preventDefault();
    if (this.classList.contains("is-visible")) {
      this.classList.remove("is-visible");
      document.querySelector("body").classList.remove("overflow-hidden");
    }
    if (focusElement) {
      focusElement.focus();
    }
    focusElement = '';
    removeTrapFocus();
  }

  handleEscapeKeyPress(event) {
    if (event.key === 'Escape') {
      this.closeDrawer(event);
    }
  }

  async handleCartUpdate() {
    // Üst üste gelen cart:updated olaylarını tekilleştir (hızlı miktar
    // değişiminde sürekli re-render / yarış durumunu önler).
    if (this._cartUpdateInFlight) {
      this._cartUpdatePending = true;
      return;
    }
    this._cartUpdateInFlight = true;
    try {
      const response = await fetch(this.dataset.url);
      const html = await response.text();

      this.innerHTML = this.getSectionHTML(html, 'cart-drawer');

      this.querySelectorAll('[data-drawer-close]').forEach((button) =>
        button.addEventListener('click', this.closeDrawer.bind(this))
      );

      // Add overlay click event to close drawer after cart update
      const overlay = this.querySelector('.overlay');
      if (overlay) {
        overlay.addEventListener('click', this.closeDrawer.bind(this));
      }

      this.setupDialogEvents();
      this.setClearCartButton();
      window.HPCartLimits?.syncUI?.();

      const cartIconBubble = document.querySelector('#cart-icon-bubble');
      if (cartIconBubble) {
        const bubbleResponse = await fetch(`/?section_id=cart-icon-bubble`);
        const bubbleHtml = await bubbleResponse.text();
        const parser = new DOMParser();
        const doc = parser.parseFromString(bubbleHtml, 'text/html');
        const newBubble = doc.querySelector('.shopify-section');
        if (newBubble) {
          cartIconBubble.innerHTML = newBubble.innerHTML;
        }
      }
    } catch (error) {
      console.error('Error updating cart drawer:', error);
    } finally {
      this._cartUpdateInFlight = false;
      if (this._cartUpdatePending) {
        this._cartUpdatePending = false;
        this.handleCartUpdate();
      }
    }
  }

  setClearCartButton() {
    const clearButton = this.querySelector('.cart-remove-all-button button');
    if (clearButton && !clearButton.dataset.listenerAdded) {
      clearButton.dataset.listenerAdded = 'true';
      clearButton.addEventListener('click', async () => {
        try {
          const originalText = clearButton.querySelector('span').textContent;
          clearButton.disabled = true;
          clearButton.querySelector('span').textContent = 'Temizleniyor...';
          
          const response = await fetch('/cart/clear.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              sections: 'api-bag-calculate,api-campaign-calculate',
              sections_url: window.location.pathname,
            }),
          });

          if (response.ok) {
            const clearData = await response.json();
            if (clearData?.sections && typeof window.dispatchBagCalculateIfNeeded === 'function') {
              window.dispatchBagCalculateIfNeeded(clearData);
            }
            if (clearData?.sections && typeof window.dispatchCampaignCalculateIfNeeded === 'function') {
              window.dispatchCampaignCalculateIfNeeded(clearData);
            }
            const sectionsResponse = await fetch(this.dataset.url);
            const html = await sectionsResponse.text();
            this.innerHTML = this.getSectionHTML(html, 'cart-drawer');

            this.querySelectorAll('[data-drawer-close]').forEach((button) =>
              button.addEventListener('click', this.closeDrawer.bind(this))
            );

            // Add overlay click event to close drawer after cart clear
            const overlay = this.querySelector('.overlay');
            if (overlay) {
              overlay.addEventListener('click', this.closeDrawer.bind(this));
            }

            this.setupDialogEvents();
            this.setClearCartButton();
            
            const cartIconBubble = document.querySelector('#cart-icon-bubble');
            if (cartIconBubble) {
              const bubbleResponse = await fetch(`/?section_id=cart-icon-bubble`);
              const bubbleHtml = await bubbleResponse.text();
              const parser = new DOMParser();
              const doc = parser.parseFromString(bubbleHtml, 'text/html');
              const newBubble = doc.querySelector('.shopify-section');
              if (newBubble) {
                cartIconBubble.innerHTML = newBubble.innerHTML;
              }
            }
            
            document.dispatchEvent(new CustomEvent('cart:updated'));
          } else {
            console.error('Cart clear failed:', response);
            clearButton.disabled = false;
            clearButton.querySelector('span').textContent = originalText;
          }
        } catch (error) {
          console.error('Error clearing cart:', error);
          clearButton.disabled = false;
          clearButton.querySelector('span').textContent = 'Tümünü Kaldır';
        }
      });
    }
  }
}

customElements.define('cart-drawer', CartDrawer);